import { InjectionToken } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";

export const DIALOG_SERVICE_TOKEN = new InjectionToken<DialogService>("DialogService");
